// Shared helpers for the Admin dashboard tab components. Extracted from
// AdminPage.jsx so per-tab files stay small and independently testable.
import { format, parseISO } from "date-fns";

/** Human-friendly datetime formatter tolerant to missing/invalid values. */
export function fmt(dt) {
  try { return format(parseISO(dt), "MMM d, yyyy · h:mm a"); } catch { return dt || ""; }
}

/** Build a CSV file client-side and trigger a browser download. */
export function csvDownload(filename, rows, columns) {
  const esc = (s) => `"${String(s ?? "").replace(/"/g, '""')}"`;
  const head = columns.map((c) => esc(c.label)).join(",");
  const body = rows.map((r) => columns.map((c) => esc(c.get(r))).join(",")).join("\n");
  const blob = new Blob([head + "\n" + body], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
